export default class Form {

	constructor (options) {
		this.el = options.element;
		this.trigger = this.el.find(".js-button");
		this.endPoint = this.el.attr("action");
		this.displayElem = this.el.find(".js-message");
		this.displayElem.hide();

		this.el.on("submit", jQuery.proxy(this.postHandler, this));
	}

	wpSuccessHandler(response) {
		this.displayMessage(response.message, "info");
		this.el[0].reset();
		this.el.find(".form__form").fadeOut(() => {
			this.el.find(".form__success").fadeIn();
		});
		this.el.find(".form__field").removeClass("form__field--error");
	}

	wpErrorHandler(response) {
		this.el.find(".form__field").removeClass("form__field--error");

		var message = response.message;
		if (response.data.formErrors) {
			jQuery.each(response.data.formErrors, (key, value) => {
				this.el.find("#"+key).parents(".form__field").addClass("form__field--error");
			});

			if (response.data.formErrors.empty) {
				message = response.data.formErrors.empty;
			} else if (response.data.formErrors.email) {
				message = response.data.formErrors.email;
			}
		}

		this.displayMessage(message, "error");
	}

	ajaxErrorHandler(data) {
		console.log(data);
	}

	displayMessage(message, type) {
		this.displayElem.text(message);
		this.displayElem.removeClass("error info");
		this.displayElem.addClass(type);
		this.displayElem.show();
	}

	postHandler(ev) {
		ev.preventDefault();

		if (this.trigger.disableClick) {
			return false;
		}

		this.trigger.disableClick = true;

		var formData = new FormData(this.el[0]);

		jQuery.ajax({
			url: this.endPoint,
			data: formData,
			type: "POST",
			processData: false,
			contentType: false,
		}).done((data) => {
			var response = JSON.parse(data);
			if (response.success) {
				this.wpSuccessHandler(response);
			} else {
				this.wpErrorHandler(response);
			}
		}).error((data) => {
			this.ajaxErrorHandler(data);
		}).always((data) => {
			setTimeout(() => {
				this.trigger.disableClick = false;
			}, 1000);
		});
	}
}
